import { stripCandidateResourceFunctions } from './candidateCssResources';

const splitRules = (css: string): string[] => {
    const rules: string[] = [];
    let start = 0;
    let depth = 0;
    let quote = '';
    let comment = false;
    let escaped = false;
    for (let index = 0; index < css.length; index++) {
        const char = css[index];
        const next = css[index + 1];
        if (comment) {
            if (char === '*' && next === '/') {
                comment = false;
                index += 1;
            }
        } else if (quote) {
            if (!escaped && char === quote) quote = '';
            escaped = !escaped && char === '\\';
        } else if (char === '/' && next === '*') {
            comment = true;
            index += 1;
        } else if (char === '"' || char === "'") {
            quote = char;
        } else if (char === '{') {
            depth += 1;
        } else if (char === '}') {
            depth -= 1;
            if (depth === 0) {
                rules.push(css.slice(start, index + 1));
                start = index + 1;
            }
        } else if (char === ';' && depth === 0) {
            start = index + 1;
        }
    }
    return rules;
};

// eslint-disable-next-line import/prefer-default-export
export const sanitizeCandidateStylesheet = (
    css: string,
    sanitizeDeclarations: (declarations: string) => string,
): string => {
    const sheet = new CSSStyleSheet();
    splitRules(stripCandidateResourceFunctions(css, true).css).forEach((rule) => {
        try {
            sheet.insertRule(rule, sheet.cssRules.length);
        } catch {
            // Invalid/unsupported CSS is omitted, not the message body or other valid rules.
        }
    });
    const renderRules = (rules: CSSRuleList): string => Array.from(rules).map((rule) => {
        if (rule.type === CSSRule.STYLE_RULE) {
            const styleRule = rule as CSSStyleRule;
            const declarations = sanitizeDeclarations(styleRule.style.cssText);
            return declarations ? `${styleRule.selectorText} { ${declarations} }` : '';
        }
        if (rule.type === CSSRule.MEDIA_RULE) {
            const media = rule as CSSMediaRule;
            return `@media ${media.conditionText || media.media.mediaText} { ${renderRules(media.cssRules)} }`;
        }
        return '';
    }).join('\n');
    return renderRules(sheet.cssRules).replace(/</g, '\\3c ');
};
